var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebClientLogoTextWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245.7 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #133d68;\n      }\n\n      .st1 {\n        fill: #64a1bb;\n      }\n\n      .st2 {\n        fill: #003d6a;\n      }\n\n      .st3 {\n        fill: #fab600;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.4,28.8l-1.2-3.7h-6.6l-1.2,3.7h-3.4l5.9-17.6h4.4l5.9,17.6h-3.7ZM41.6,16.8c-.3-.9-.5-1.8-.7-2.6h0c-.2.8-.4,1.7-.7,2.6l-1.8,5.5h5.1l-1.8-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.5,21.9c0,4.8-2.7,7.1-7.3,7.1s-6.8-3-6.8-6.4v-11.5h3.4v11.3c0,2.2.7,3.8,3.6,3.8s3.7-1.1,3.7-4.1v-10.9h3.4v10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.1,27.9c-1.7.7-3.9,1.1-6,1.1-5.8,0-8.9-3.3-8.9-8.5s3.4-9.6,9.8-9.6,3.6.3,5,.8l-.7,3.1c-1.3-.5-2.9-.8-4.5-.8-4.2,0-5.9,2.8-5.9,6.1s2,5.9,5.6,5.9,1.6-.1,2.2-.3v-6.1h3.4v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.6,28.8V11.2h3.4v17.6h-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.3,28.8l-1.2-3.7h-6.6l-1.2,3.7h-3.4l5.9-17.6h4.4l5.9,17.6h-3.7ZM99.6,16.8c-.3-.9-.5-1.8-.7-2.6h0c-.2.8-.4,1.7-.7,2.6l-1.8,5.5h5.1l-1.8-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.6,14.2c-1-.3-2-.5-3.1-.5-2,0-2.9.8-2.9,2,0,3.2,7.6,2.1,7.6,7.8s-2.4,5.5-6.8,5.5-2.9-.2-4.1-.5l.4-3.2c1.1.5,2.6.8,3.9.8s3-.7,3-2.2c0-3.3-7.5-2.1-7.5-7.8s2.4-5.2,6.6-5.2,2.2.1,3.2.3l-.3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.9,13.2c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5,2.5,1.1,2.5,2.5-1.2,2.5-2.5,2.5ZM121.9,8.8c-1,0-1.8.8-1.8,1.9s.8,1.9,1.8,1.9,1.8-.8,1.8-1.9-.8-1.9-1.8-1.9ZM122.2,12l-.6-1.1h0v1.1h-.6v-2.6h.9c.6,0,.9.3.9.7s-.2.7-.6.8c0,0,.1.2.2.3l.5.8h-.7ZM121.6,10.5h.2c.4,0,.5-.2.5-.4s-.1-.3-.4-.3h-.2v.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123,22.9v-2.7h6.4v2.7h-6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151,28.8h-4.2l-2.7-9.6c-.2-.9-.4-2.1-.6-3.2h0c-.2,1.1-.3,2.3-.5,3.2l-2.6,9.6h-4.2l-4.4-17.6h3.6l2.3,9.6c.3,1.6.6,3,.8,4.4h0c.2-1.3.4-2.8.8-4.3l2.7-9.6h3.4l2.7,9.8c.4,1.3.7,2.8.9,4.2h0c.2-1.4.4-2.8.7-4.2l2.3-9.8h3.3l-4.4,17.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.5,28.2c-1.5.5-3.1.8-4.6.8-4.1,0-6.4-2.1-6.4-6.6s2.3-6.8,6.1-6.8,5.4,2.4,5.4,5.5-.1,2-.1,2h-8c0,2.2,1,3.4,3.4,3.4s2.6-.2,3.9-.7l.3,2.5ZM163.7,20.8c0-1.8-.8-2.8-2.2-2.8s-2.4,1-2.5,2.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.7,15.3c0,.8,0,1.8-.2,2.5h0c.6-1.4,2.1-2.3,3.9-2.3,3.1,0,4.8,2.2,4.8,6.1s-2.5,7.4-7,7.4-4.8-.6-4.8-.6V9.8h3.3v5.6ZM172.7,26.1s.8.3,1.7.3c1.9,0,3.2-1.2,3.2-4.4s-.7-3.6-2.2-3.6-2.8,2-2.8,4.2v3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.5,28.1c-1.3.5-2.9.9-4.6.9-6.1,0-8.1-4.1-8.1-8.5s3-9.5,8.7-9.5,2.7.2,3.9.6l-.5,3.1c-1.1-.5-2.3-.7-3.5-.7-3.2,0-4.8,2.6-4.8,6s1.6,5.8,5,5.8,2.5-.4,3.5-.8l.5,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198,28.8V9.8h3.3v19h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.2,13.9c-1.1,0-2.1-.9-2.1-2s.9-2,2.1-2,2.1.9,2.1,2-.9,2-2.1,2ZM204.6,28.8v-12.9h3.3v12.9h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.3,28.2c-1.5.5-3.1.8-4.6.8-4.1,0-6.4-2.1-6.4-6.6s2.3-6.8,6.1-6.8,5.4,2.4,5.4,5.5-.1,2-.1,2h-8c0,2.2,1,3.4,3.4,3.4s2.6-.2,3.9-.7l.3,2.5ZM218.4,20.8c0-1.8-.8-2.8-2.2-2.8s-2.4,1-2.5,2.8h4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.1,28.8v-8.2c0-1.4-.4-2.2-1.6-2.2s-3,1.8-3,4.2v6.2h-3.3v-12.9h3.1c0,.6,0,1.6-.2,2.3h0c.8-1.5,2.3-2.6,4.4-2.6s3.9,1.6,3.9,4.2v8.9h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.7,28.7c-.8.2-1.9.4-2.8.4-2.9,0-3.8-1-3.8-4.1v-6.5h-2.2v-2.6h2.2v-4l3.3-.9v4.9h3.1v2.6h-3.1v5.9c0,1.5.3,2,1.5,2s1.1,0,1.5-.2l.2,2.6Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.2,20.7c0,7.7-6.2,13.9-13.9,13.9S.4,28.3.4,20.7,6.6,6.8,14.3,6.8s13.9,6.2,13.9,13.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.8,20.5c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5,2-4.5,4.5-4.5,4.5,2,4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.3,20.5c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.3,29.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.3,14.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.3,13.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 8.8,
    y: 13.4,
    width: 1,
    height: 7.2,
    transform: "translate(-10 15.3) rotate(-56.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 16,
    y: 15.7,
    width: 6.2,
    height: 1,
    transform: "translate(-5.8 18.5) rotate(-45.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 14.6,
    y: 23.4,
    width: 1,
    height: 6.6,
    transform: "translate(-1.5 .9) rotate(-3.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebClientLogoTextWeb);
export default __webpack_public_path__ + "static/media/WebClient-Logo-Text-Web.ab2495c838255ba99db4b069cfad8a20.svg";
export { ForwardRef as ReactComponent };